module.exports = __webpack_public_path__ + "img/pay-res-success.bb7c9c3b.png";